import Modal from './Modal';

/**
 * Reusable confirmation popup — thin wrapper around Modal.
 *
 * Props:
 *   show            — whether the popup is visible
 *   title           — heading text
 *   message         — body text
 *   confirmLabel    — text for the confirm button (default: "Confirm")
 *   confirmDisabled — disable the confirm button
 *   danger          — use danger-styled confirm button
 *   onConfirm       — called when user clicks confirm
 *   onClose         — called when user clicks cancel / overlay
 */
function ConfirmPopup({
  show,
  title,
  message,
  confirmLabel = 'Confirm',
  confirmDisabled = false,
  danger = false,
  onConfirm,
  onClose,
}) {
  return (
    <Modal
      show={show}
      title={title}
      onClose={onClose}
      modalStyle={{ height: 'auto', maxHeight: '90vh' }}
      footer={
        <>
          <button
            className={`btn${danger ? ' btn-danger' : ' btn-primary'}`}
            onClick={onConfirm}
            disabled={confirmDisabled}
          >
            {confirmLabel}
          </button>
          <button
            className="btn"
            onClick={onClose}
          >
            Cancel
          </button>
        </>
      }
    >
      <p style={{ color: 'var(--ink-muted)', lineHeight: 'var(--leading)', margin: 0, whiteSpace: 'pre-line' }}>
        {message}
      </p>
    </Modal>
  );
}

export default ConfirmPopup;
